import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const AddDesignationModal = ({ open, onClose, onSave, editData }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (open) {
      setName(editData?.name || "");
    } else {
      setName("");
    }
  }, [open, editData]);

  if (!open) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">
        <div className="admin-modal-header">
          <div className="admin-modal-title">
            {editData ? "Edit Designation" : "Add Designation"}
          </div>
          <button className="admin-modal-close" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <div className="admin-form-body">
          <label className="admin-label">Designation Name <span>*</span></label>
          <input
            className="admin-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Designation Name"
            required
          />
        </div>

        <div className="admin-form-footer">
          <button className="admin-btn-cancel" onClick={onClose}>
            CANCEL
          </button>
          <button className="admin-btn-save" disabled={!name.trim()}
            onClick={() => onSave({ name })}>
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDesignationModal;
